import { ApprovalStatus } from './approvalStatus';

export enum TransactionType {
  BUY = 'BUY',
  RESERVE = 'RESERVE',
}

export interface OfferingTransactionReview {
  id: number;
  user: ReviewUser;
  offeringId: number;
  offeringTransactionId: number;
  approvalStatus: ApprovalStatus;
  transactionType: TransactionType;
  review: string;
  sharesCount: number;
  sharePrice: number;
  totalAmount: number;
  showAmount: boolean;
  transactionDate: Date;
  createdAt: Date;
  active: boolean;
}

export interface CreateOfferingTransactionReviewRequest {
  offeringTransactionId: number;
  review: string;
  showAmount: boolean;
}

export interface UpdateOfferingTransactionReviewRequest {
  offeringTransactionId: number;
  review?: string;
  showAmount?: boolean;
  approvalStatus?: ApprovalStatus;
}

interface ReviewUser {
  id: number;
  firstName: string;
  lastNameInitial: string;
  profilePictureUrl?: string;
}
